import React from 'react';

// eslint-disable-next-line max-len
const EMBELLISHEDLONDON = '/themes/theme/embellishedlondon/logo.png';
const EMBELLISHEDLONDON_DARK_LOGO = '/themes/theme/embellishedlondon/logo.png';

const EmbellishedlondonTheme = {
  headerLogo: {
    src: EMBELLISHEDLONDON,
    alt: 'Embellished London Logo',
    size: 80,
  },
  darkLogo: {
    src: EMBELLISHEDLONDON_DARK_LOGO,
    alt: 'Embellished London Logo',
    size: 80,
  },
  linkStyle: {
    color: '#ee1090',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #ee1090',
    height: 100,
  },
  title: 'Embellished London',
  isLightOnDark: false,
  organisationId: '730c6c28-07a4-47e9-b4ca-e50403ddb5ac',
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="80"
        src={EMBELLISHEDLONDON_DARK_LOGO} alt="Embellished London Logo"
      />
      <br /><br />
      {/* <h3>Embellished London</h3> */}
    </div>
  ),
  shareSite: 'https://share.embellishedlondon.com',
};

export default EmbellishedlondonTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/embellishedlondon.js
 **/